import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { styles } from './DesktopLinkedAccountsStyles';

interface DesktopConnectionsTabsHeaderProps {
  firstTabTitle: string;
  accountsCount: number;
  invitationsCount?: number;
  activeTab: 'accounts' | 'invitations' | 'how';
  setActiveTab: (tab: 'accounts' | 'invitations' | 'how') => void;
}

export const DesktopConnectionsTabsHeader: React.FC<DesktopConnectionsTabsHeaderProps> = ({
  firstTabTitle,
  accountsCount,
  invitationsCount,
  activeTab,
  setActiveTab,
}) => {
  return (
    <View style={styles.tabs}>
      <TouchableOpacity
        accessibilityRole="button"
        onPress={() => setActiveTab('accounts')}
        style={[styles.tabItem, activeTab === 'accounts' && styles.tabItemActive]}
      >
        <View style={styles.tabHeaderRow}>
          <Text style={[styles.tabTitleText, activeTab === 'accounts' && styles.tabTitleTextActive]}>
            {firstTabTitle}
          </Text>
          <View style={[styles.countPill, !accountsCount && styles.countPillHidden]}>
            <Text style={styles.countPillText}>{accountsCount}</Text>
          </View>
        </View>
        <Text style={styles.subTitleText}>
          View the people you're connected to
        </Text>
        <View style={[styles.activeBorder, styles.activeBorderAccounts]} />
      </TouchableOpacity>

      <TouchableOpacity
        accessibilityRole="button"
        onPress={() => setActiveTab('invitations')}
        style={[styles.tabItem, activeTab === 'invitations' && styles.tabItemActive]}
      >
        <View style={styles.tabHeaderRow}>
          <Text style={[styles.tabTitleText, activeTab === 'invitations' && styles.tabTitleTextActive]}>Invitations</Text>
          <View style={[styles.countPill, (invitationsCount === undefined || invitationsCount === 0) && styles.countPillHidden]}>
            <Text style={styles.countPillText}>{invitationsCount === undefined ? '.. .' : invitationsCount}</Text>
          </View>
        </View>
        <Text style={styles.subTitleText}>
          Manage your invitations
        </Text>
        <View style={[styles.activeBorder, styles.activeBorderInvitations]} />
      </TouchableOpacity>

      <TouchableOpacity
        accessibilityRole="button"
        onPress={() => setActiveTab('how')}
        style={[styles.tabItem, activeTab === 'how' && styles.tabItemActive]}
      >
        <View style={styles.tabHeaderRow}>
          <Text style={styles.tabTitleText}>How it works</Text>
        </View>
        <Text style={styles.subTitleText}>
          Discover how to use the connections
        </Text>
        <View style={[styles.activeBorder, styles.activeBorderHow]} />
      </TouchableOpacity>
    </View>
  );
};


